import React from 'react';
import classNames from 'classnames';
import { func, array, bool } from 'prop-types';
import { Radio, Checkbox } from '@fiverr-private/fit';
import './index.scss';

const List = ({ items, selected, onSelect, isMulti = false }) => {
    const Component = isMulti ? Checkbox : Radio;

    return (
        <div className="list">
            <div>
                {items.map((item) => (
                    <Component name={item.id}
                        key={item.id}
                        className={classNames('list-item', { 'multi': isMulti })}
                        onChange={(e) => onSelect(item, e.target.checked)}
                        checked={isMulti ? selected.includes(item.id) : selected === item.id}
                        value={item.id}>
                        <div className="inner-text">
                            <span className="label">{item.alias}</span>
                            <span className="count"> {item.count && `(${item.count.toLocaleString()})`}</span>
                        </div>
                    </Component>
                ))}
            </div>
        </div>
    );
};

List.propTypes = {
    items: array,
    selected: array,
    onSelect: func,
    isMulti: bool
};

export default List;
